export default __webpack_public_path__ + "static/media/rune.c4de9bab.png";